import { useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";
import { Schedule } from "@mui/icons-material";
import moment from "moment";
import styles from "../../Styles/examCountdownTimer.module.css";

interface CountdownState {
  days: number;
  hours: number;
  minutes: number;
  seconds: number;
}

interface ExamCountdownTimerProps {
  examDate: string;
}

export default function ExamCountdownTimer({ examDate }: ExamCountdownTimerProps) {
  const [countdown, setCountdown] = useState<CountdownState>({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
  });
  const [isExpired, setIsExpired] = useState(false);

  useEffect(() => {
    // Initial calculation
    const updateCountdown = () => {
      // Always set to 8 AM on the exam date, ignoring any time in examDate
      const examDateTime = moment(examDate).startOf('day').set({ hour: 8, minute: 0, second: 0 });
      const now = moment();

      if (examDateTime.isBefore(now)) {
        setIsExpired(true);
        setCountdown({ days: 0, hours: 0, minutes: 0, seconds: 0 });
        return;
      }

      const diff = examDateTime.diff(now);
      const duration = moment.duration(diff);

      setCountdown({
        days: Math.floor(duration.asDays()),
        hours: duration.hours(),
        minutes: duration.minutes(),
        seconds: 0,
      });
    };

    updateCountdown();

    // Update every 60 seconds (since we don't show seconds)
    const interval = setInterval(updateCountdown, 60000);

    return () => clearInterval(interval);
  }, [examDate]);

  if (isExpired) {
    return (
      <Box className={styles.timerContainer}>
        <Typography variant="body2" className={styles.expiredText}>
          Examenul a fost
        </Typography>
      </Box>
    );
  }

  return (
    <Box className={styles.timerContainer}>
      <Box className={styles.timerHeader}>
        <Schedule className={styles.timerIcon} />
        <Typography variant="body2" className={styles.timerLabel}>
          Timp rămas
        </Typography>
      </Box>

      <Box className={styles.countdownDisplay}>
        <Box className={styles.countdownUnit}>
          <Typography className={styles.countdownValue}>{countdown.days}</Typography>
          <Typography className={styles.countdownLabel}>Zile</Typography>
        </Box>

        <Typography className={styles.separator}>:</Typography>

        <Box className={styles.countdownUnit}>
          <Typography className={styles.countdownValue}>
            {String(countdown.hours).padStart(2, "0")}
          </Typography>
          <Typography className={styles.countdownLabel}>Ore</Typography>
        </Box>

        <Typography className={styles.separator}>:</Typography>

        <Box className={styles.countdownUnit}>
          <Typography className={styles.countdownValue}>
            {String(countdown.minutes).padStart(2, "0")}
          </Typography>
          <Typography className={styles.countdownLabel}>Min</Typography>
        </Box>
      </Box>
    </Box>
  );
}
